import { Container } from "react-bootstrap";
import { useEffect, useState } from "react";
import moment from "moment";
import { getAllNotification, makAsReadNotification, markAllAsReadNotification } from "../../../store/api/apiSlice";
import { useAppDispatch } from "../../../store/hooks";
import { useTranslation } from "react-i18next";
import { setrefreshNotificationPage } from "../../../store/slice/hierarchy";
import { useSelector } from "react-redux";
export const Notifications = () => {
    const [nonnotifications, setNoNotifications] = useState("");
  const [notifications, setNotifications] = useState<any>([]);
  const refreshNotificationFlag = useSelector((state: any) => state?.accounts?.refreshNotificationFlag) || '';
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  useEffect(() => {
    refresData();
  }, []);

  const redirectTo = (notification: any) => {
    const data = {
      id: [notification.id],
      isReadAll: false
    };
    if (notification.isRead === false) {
      markAsRead(data);
      setInstatntRead(notification.id);
    }
  }
  const markAsRead = (data: object) => {
    dispatch(makAsReadNotification(data)).then((result: any) => {
      //  refresData();
    });
  }
  const setInstatntRead = (Id: any) => {
    let updatedNotifications = notifications?.map((notification: any) => {
      if (notification.id === Id) {
        dispatch(setrefreshNotificationPage(Id));
        return { ...notification, isRead: true };
      } else {
        return notification;
      }
    });
    setNotifications(updatedNotifications)
  }

  const refresData = () => {
    dispatch(getAllNotification()).then((result: any) => {
      setNotifications(result?.payload?.data);
      setNoNotifications(result?.payload?.data?.length === 0 ? t('NO_NEW_NOTIFICATION') : "");
    });
  }

  useEffect(() => {
    const data = {
      id: [refreshNotificationFlag],
      isReadAll: false
    };

    if (refreshNotificationFlag != "" && refreshNotificationFlag != "all") {
      markAsRead(data);
      setInstatntRead(refreshNotificationFlag);
    }
    if (refreshNotificationFlag === "all") {
      refresData();
      dispatch(setrefreshNotificationPage(""));
    }
  }, [refreshNotificationFlag]);

  const readAllnotification = () => {
    const data = {
      isReadAll: true
    };
    dispatch(markAllAsReadNotification(data)).then((result: any) => {
      refresData();
      dispatch(setrefreshNotificationPage("all"));
    });
  }

  return (
    <>
      <Container fluid>
        <div className="content_header d-flex justify-content-between align-items-center">
          <div className="header_left">
            <h5 className="content_header_title">Notifications</h5>
          </div>
          <div>
            {notifications?.length > 0 &&
              <a href="#" onClick={() => readAllnotification()}>Read All</a>
            }
          </div>
        </div>
        <div className="content_body">
          <div className="notify-list-wrapper notify-page">
            {notifications?.length > 0 &&
              <ul>
                {notifications?.map((notification: any, index: any) => (
                  <li key={index} className="cursor_pointer">
                    <a onClick={() => redirectTo(notification)}>
                      <div className="icon">
                        <i className="fa-solid fa-bell"></i>
                        {!notification?.isRead &&
                          <span className="recent-notify"></span>
                        }
                      </div>
                      <div className="detail">
                        <p>{notification?.message}</p>
                        <small>{moment(notification?.createdOn).format('MMMM DD, YYYY hh:mm A')}</small>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            }
            {nonnotifications?.length > 0 && (
              <div className="no-records-wrapper mincardheight justify-content-center">
                <svg
                  width="48"
                  height="42"
                  viewBox="0 0 48 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 5.25C0 2.3543 2.39167 0 5.33333 0H18.6667V10.5C18.6667 11.952 19.8583 13.125 21.3333 13.125H32V16.2914C25.8417 18.0059 21.3333 23.5758 21.3333 30.1875C21.3333 35.0355 23.7583 39.3176 27.475 41.9426C27.2083 41.9836 26.9417 42 26.6667 42H5.33333C2.39167 42 0 39.6457 0 36.75V5.25ZM32 10.5H21.3333V0L32 10.5ZM36 18.375C39.1826 18.375 42.2348 19.6195 44.4853 21.8348C46.7357 24.0501 48 27.0546 48 30.1875C48 33.3204 46.7357 36.3249 44.4853 38.5402C42.2348 40.7555 39.1826 42 36 42C32.8174 42 29.7652 40.7555 27.5147 38.5402C25.2643 36.3249 24 33.3204 24 30.1875C24 27.0546 25.2643 24.0501 27.5147 21.8348C29.7652 19.6195 32.8174 18.375 36 18.375ZM36 38.0625C36.5304 38.0625 37.0391 37.8551 37.4142 37.4859C37.7893 37.1167 38 36.6159 38 36.0938C38 35.5716 37.7893 35.0708 37.4142 34.7016C37.0391 34.3324 36.5304 34.125 36 34.125C35.4696 34.125 34.9609 34.3324 34.5858 34.7016C34.2107 35.0708 34 35.5716 34 36.0938C34 36.6159 34.2107 37.1167 34.5858 37.4859C34.9609 37.8551 35.4696 38.0625 36 38.0625ZM36 22.3125C35.2667 22.3125 34.6667 22.9031 34.6667 23.625V30.1875C34.6667 30.9094 35.2667 31.5 36 31.5C36.7333 31.5 37.3333 30.9094 37.3333 30.1875V23.625C37.3333 22.9031 36.7333 22.3125 36 22.3125Z"
                    fill="#3F475C"
                    fillOpacity="0.3"
                  />
                </svg>
                <span>{nonnotifications}</span>
              </div>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export default Notifications;